import FieldArray from "@/components/form/FieldArray.tsx";
import FieldObject from "@/components/form/FieldObject.tsx";
import SectionTitle from "@/components/editor/SectionTitle.tsx";
import Field from "@/components/form/Field.tsx";
import {RadioGroup, RadioGroupItem} from "@/components/ui/radio-group.tsx";
import {Label} from "@/components/ui/label.tsx";
import CurrencyField from "@/components/editor/fields/CurrencyField.tsx";
import NyugdijSlider from "@/components/editor/fields/NyugdijSlider.tsx";
import NyugdijLongTextField from "@/components/editor/fields/NyugdijLongTextField.tsx";
import {Checkbox} from "@/components/ui/checkbox.tsx";

export default function NyugdijEditor() {
    return (
        <FieldArray name={"cegkepviseletArray"}>
            {(array) => array.map((actions,) => {
                if(actions.getValues()["general"]["isPerson"]) {
                    const a = Math.floor((Date.now() - Date.parse(actions.getValues()["general"]?.["birth_date"] ?? Date.now())) / (24 * 3600 * 1000) / 365)
                    const age = a > 0 ? a : 0
                    return (
                        <>{

                            actions.getValues()["general"]["isPerson"] ?
                                <FieldObject key={actions.key} name={"nyugdij"}>
                                    <div className={"flex flex-col gap-4 p-4 bg-white rounded-md"}>
                                        <SectionTitle>{actions.getValues()["general"]["name"]}</SectionTitle>
                                        <p>
                                            {new Date(actions.getValues()["general"]["birth_date"]).toLocaleDateString('hu-HU')} ({age} éves)
                                        </p>
                                        <SectionTitle>Milyen módon szeretné nyugdíjas éveit tölteni?</SectionTitle>
                                        <Field name={"mod"} defaultValue={"kamat"}>
                                            {(field) =>
                                                <RadioGroup value={field.value} onValueChange={field.onChange}>
                                                    <div className={"flex w-full justify-evenly"}>
                                                        <div className={"flex gap-1 cursor-pointer"}>
                                                            <RadioGroupItem id={"kamat_radio"} value={"kamat"}/>
                                                            <Label htmlFor={"kamat_radio"}>Felhalmozott vagyon
                                                                kamatjából</Label>
                                                        </div>
                                                        <div className={"flex gap-1 cursor-pointer"}>
                                                            <RadioGroupItem id={"feleles_radio"} value={"feleles"}/>
                                                            <Label htmlFor={"feleles_radio"}>Felhalmozott vagyon
                                                                felélése</Label>
                                                        </div>
                                                    </div>
                                                </RadioGroup>}
                                        </Field>
                                        <div className={"flex gap-4 w-full mt-4"}>
                                            <CurrencyField name={"monthly_need"}
                                                           label={"Mennyire van szüksége havi szinten?"}
                                                           validate={(v) =>  v.value ? undefined : {label:"Mennyire van szüksége havi szinten?", text: "Ez a mező kötelező!"}}/>
                                            <CurrencyField name={"monthly_actual"} label={"Megtakarítható havi összeg"}
                                                           validate={(v) =>  v.value ? undefined : {label:"Megtakarítható havi összeg", text: "Ez a mező kötelező!"}}/>
                                        </div>
                                        <SectionTitle>Mikor akar nyugdíjba menni?</SectionTitle>
                                        <Field name={"slider"}
                                               defaultValue={[age, age >= 65 ? age + 1 : 65, age >= 65 ? 100 : 75]}>
                                            {(field) => (
                                                <NyugdijSlider page={0} {...field}
                                                               value={[age, field.value?.[1], field.value?.[2]]}
                                                               enableDead={actions.getValues()?.["nyugdij"]?.["mod"] == "feleles"}/>
                                            )}
                                        </Field>
                                        <NyugdijLongTextField label={"Célok"} name={"longtext"} defaultValue={"-"}/>
                                        <Field name={"szja"}>
                                            {(field) => (
                                                <Label className={"flex gap-2 items-center pb-4"}>
                                                    <Checkbox checked={field.value} onCheckedChange={field.onChange}/>
                                                    <p>
                                                        SZJA magán nyugdíj
                                                    </p>
                                                </Label>
                                            )}
                                        </Field>
                                    </div>
                                </FieldObject> : <></>
                        }</>
                    )
                } else {
                    return <></>
                }
            })}
        </FieldArray>
    )
}